<template>
    <div class="wrapper">
        <div :class="['layer clouds', {'loop': loopMode}]" :style="{'background-image': `url(${require('@/assets/img/login/clouds.png')})`}"></div>
        <div :class="['layer rings', {'loop': loopMode}]" :style="{'background-image': `url(${require('@/assets/img/login/0.png')})`}"></div>
        <div :class="['layer utils', {'loop': loopMode}]" :style="{'background-image': `url(${require('@/assets/img/login/1.png')})`}"></div>
        <div :class="['layer books', {'loop': loopMode}]" :style="{'background-image': `url(${require('@/assets/img/login/2.png')})`}"></div>
    </div>
</template>
<script>
    export default{
        props: {
            loopMode:{
                type: Boolean,
                default: true
            }
        }
    }
</script>
<style scoped>

    :root {
        --layer-scale: .7;
    }

    .wrapper{
        position: fixed;
        background: rgb(155,180,236);
        background: linear-gradient(180deg, rgba(155,180,236,1) 0%, rgba(65,106,214,1) 84%);
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 0;
    }

    .layer{
        position: absolute;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        transform: scale(var(--layer-scale));
        animation-iteration-count: 0, 0;
    }

    .layer.loop{
        animation-iteration-count: 1, infinite;
    }

    .clouds{
        top: -150px;
        left: 0;
        width: 100%;
        height: 100%;
        transform: scale(var(--layer-scale));
        opacity: .5;
        animation:
            appear 2s,
            clouds 3s;
        animation-delay: 0s, 2s;
        z-index: 1;
    }

    .rings{
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-size: 70%;
        transform: scale(var(--layer-scale));
        opacity: .3;
        animation:
                appear 2s,
                rings 3s linear;
        animation-delay: 0s, 2s;
        z-index: 2;
    }

    .utils{
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-size: 60%;
        transform: scale(var(--layer-scale));
        animation:
                appear 2s,
                utils 3s;
        animation-delay: 0s, 2s;
        z-index: 2;
    }

    .books{
        top: -10%;
        left: 2%;
        width: 100%;
        height: 100%;
        background-size: 85%;
        transform: scale(var(--layer-scale));
        opacity: .4;
        animation:
                appear 2s,
                books 3s;
        animation-delay: 0s, 2s;
        z-index: 1;
    }


    @media screen and (max-width: 860px){
        .clouds{
            background-size: 100%;
        }

        .rings{
            background-size: 150%;
        }

        .utils{
            background-size: 100%;
        }

        .books{
            background-size: 150%;
        }
    }


    @media screen and (max-width: 460px){
        .clouds{
            top: -180px;
            background-size: 150%;
        }

        .rings{
            background-size: 250%;
        }

        .utils{
            background-size: 140%;
        }

        .books{
            background-size: 200%;
        }

    }


    @keyframes appear{
        from{
            transform: scale(.7)
        }

        to{
            transform: scale(var(--layer-scale))
        }
    }

    @keyframes clouds {

        0%{
            transform: translateY(0);
        }

        50%{
            transform: translateY(10px);
        }

        100%{
            transform: translateY(0);
        }

    }

    @keyframes rings {

        from{
            transform: rotate(0deg);
        }

        to{
            transform: rotate(13.7deg);
        }


    }

    @keyframes utils {

        0%{
            transform: scale(var(--layer-scale));
        }

        40%{
            transform: scale(1.05);
        }

        100%{
            transform: scale(var(--layer-scale));
        }

    }

    @keyframes books {

        0%{
            transform: scale(var(--layer-scale));
        }

        40%{
            transform: scale(.85);
        }

        100%{
            transform: scale(var(--layer-scale));
        }

    }


</style>